<!--
  文件下载模态框组件
  功能：
  1. 显示文件树结构
  2. 支持单个文件下载
  3. 支持多个文件打包下载
  4. 支持批量下载进度显示
  5. 支持文件压缩下载
-->
<template>
  <!-- 主下载模态框 -->
  <a-modal class="modal" :title="$t('downloadFile')" :visible="visible" :closable="false" :width="830">
    
    <!-- 文件树显示区域 -->
    <div class="main">
      <a-tree
        :showLine="true"
        :defaultExpandAll="true"
        :showIcon="true"
        :selectable="false"
        :replaceFields="defaultProps"
        :tree-data="treeData"
      >
        <!-- 自定义图标 -->
        <img class="icon" slot="root" src="@/assets/file-root-icon.png">
        <img class="icon" slot="file" src="@/assets/file-icon.png">
      </a-tree>
    </div>

    <!-- 底部操作按钮 -->
    <div class="footer" slot="footer">
      <div class="close" @click="close"><img src="@/assets/back.png"/> {{$t('close')}}</div>
      <div class="download" @click="startDownload">{{$t('download')}}</div>
      <!-- <div class="download" @click="openDownloadProcess" style="width: auto">{{ $t('downloadProgress') }}</div> -->
    </div>

    <!-- 批量下载进度模态框组件 -->
    <FileDownloadProcessModal ref="fileDownloadProcessModal"></FileDownloadProcessModal>

  </a-modal>
</template>

<script>
import {getFileTreeByIds} from "@/request/api";
import FileDownloadProcessModal from "@/components/FileDownloadProcessModal.vue";

export default {
  name: 'FileDownloadConfirmModal',
  components: {
    FileDownloadProcessModal
  },
  data() {
    return {
      visible: false, // 控制主模态框显示/隐藏
      zipFileModal: false, // 控制压缩文件模态框显示/隐藏
      start: "", // 开始时间
      end:  "", // 结束时间
      zipFileInfo: {
        status: "" // 压缩文件状态
      },
      defaultProps: {
        children: 'children', // 子节点字段名
        title: 'name', // 显示字段名
        key: 'id' // 唯一标识字段名
      },
      treeData: [], // 文件树数据
      ids: [], // 选中的文件ID列表
    }
  },
  methods: {
    /**
     * 打开模态框并加载文件树
     * @param {Array} arr - 文件ID数组
     * @param {Object} start - 开始时间对象
     * @param {Object} end - 结束时间对象
     */
    open(arr, start, end) {
      this.ids = arr;
      if(start){
        this.start = this.formatTime(this.parseDate(start.data))
      }
      if(end){
        this.end = this.formatTime(this.parseDate(end.data))
      }

      getFileTreeByIds(this.ids).then(res => {
        this.treeData = res.data;
        this.visible = true;
      }).catch(error => {
        this.$message.error(this.$t('downloadError'));
      });
    },

    /**
     * 比较两个日期的大小
     * @param {String} dateStr1 - 第一个日期字符串
     * @param {String} dateStr2 - 第二个日期字符串
     * @returns {Boolean} - 如果dateStr1在dateStr2之后返回true，否则返回false
     */
    compareDates(dateStr1, dateStr2) {
      const date1 = new Date(dateStr1);
      const date2 = new Date(dateStr2);

      if (isNaN(date1.getTime()) || isNaN(date2.getTime())) {
        console.error('无效的日期格式');
        return null;
      }

      if (date1 < date2) {
        return false; // date1 在 date2 之前
      } else if (date1 > date2) {
        return true; // date1 在 date2 之后
      } else {
        return true; // 两个日期相等
      }
    },

    /**
     * 复制文本到剪贴板
     */
    copyText() {
      let oInput = document.createElement("input");
      oInput.value = this.zipFileInfo.zipPath;
      document.body.appendChild(oInput);
      oInput.select();
      document.execCommand("Copy");
      this.$message.success(this.$t('replicatingSuccess'));
      oInput.remove();
    },

    /**
     * 下载文件
     */
    startDownload() {
      this.$refs.fileDownloadProcessModal.startDownload(this.ids, this.start, this.end)
        .then(() => {
          this.$message.success(this.$t('downloadSuccess'));
        })
        .catch(error => {
          this.$message.error(this.$t('downloadError'));
        });
    },

    /**
     * 打开下载进度模态框
     */
    openDownloadProcess() {
      this.$refs.fileDownloadProcessModal.show()
    },

    /**
     * 关闭模态框
     */
    close() {
      this.visible = false;
      this.treeData = []
      this.ids = []
    },

    /**
     * 解析日期字符串
     * @param {String} timeStr - 日期字符串
     * @returns {Date} - 解析后的日期对象
     */
    parseDate(timeStr) {
      const parts = timeStr.split(/[- :]/);
      return new Date(parts[0], parts[1] - 1, parts[2], parts[3], parts[4], parts[5]);
    },

    /**
     * 格式化日期对象
     * @param {Date} date - 日期对象
     * @returns {String} - 格式化后的日期字符串
     */
    formatTime(date) {
      const year = date.getFullYear();
      const month = String(date.getMonth() + 1).padStart(2, '0');
      const day = String(date.getDate()).padStart(2, '0');
      const hour = String(date.getHours()).padStart(2, '0');
      const minute = String(date.getMinutes()).padStart(2, '0');
      const second = String(date.getSeconds()).padStart(2, '0');

      return `${year}/${month}/${day} ${hour}:${minute}:${second}`;
    }
  },
}
</script>

<style scoped lang="scss">
.modal {
  ::v-deep {
    .ant-modal{
      top: 50px;
    }
    .ant-modal-content {
      background: linear-gradient(270deg, #E6E9F6 0%, #FFFFFF 100%);
      position: relative;

      &:after {
        position: absolute;
        left: 0;
        top: 0;
        content: "";
        width: 100%;
        height: 100%;
        background-position: right bottom;
        background-size: 760px 260px;
        background-image: url("@/assets/download-bg.png");
        background-repeat: no-repeat;
        pointer-events: none;
      }
    }
  }

  .main {
    min-height: 400px;
    max-height: 600px;
    overflow: auto;
    .icon {
      width: 20px;
      height: 20px;
      margin-top: -3px;
      margin-right: 1px;
    }
  }

  .footer {
    display: flex;
    justify-content: center;
    padding: 5px 0;

    div {
      width: 80px;
      height: 37px;
      box-sizing: border-box;
      font-weight: bold;
      font-size: 14px;
      display: flex;
      align-items: center;
      justify-content: center;
      cursor: pointer;
      border-radius: 2px;
      padding: 0 10px;
    }

    .close {
      color: #000000;
      border: 1px solid #000000;

      img {
        width: 13px;
        height: 13px;
        margin-right: 3px;
      }
    }

    .download {
      color: #fff;
      background: #3366FF;
      margin-left: 30px;
    }
  }
}
</style>
